import SnackbarSystem from './SnackbarSystem'

const useSnackbarSystem = () => SnackbarSystem.shared();
export default useSnackbarSystem;
